<template>
  <div class="main-center" style="margin-top: 100px;">
    <el-card class="box-card">
      <div class="errorView">
        <el-image :src="ship1" class="errorImage" mode="aspectFit"/>
        <div class="errorTitle">{{$t('common.noPermission')}}</div>
        <div class="errorMessage">{{$t('common.noFuncPermission')}}</div>
        <el-button class="return-button" type="primary"
                   @click="returnPage">
          {{returnButton}}
        </el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import ship1 from '@/assets/image/noPermission.png'
export default {
  name: "noPermission",
  computed: {
    /*返回按钮*/
    returnButton() {
      return this.$t("common.returnButton");
    },
  },
  data() {
    return {
     ship1
    };
  },
  methods: {
    /**
     * 【返回】按钮点击，返回上一个页面
     */
    returnPage() {
      window.opener = null;
      window.open("about:blank", "_top").close()
    },
  },
  mounted() {}
};
</script>
<style lang="scss" scoped>
@import "../assets/scss/base.scss";
@import "../assets/scss/public.scss";
.errorView {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  height: 100%;
}
.errorImage{
    width: 380px;
    height: 275px;
}
.errorTitle{
    font-size: $fontF;
    color: #606266;
    font-weight: bold;
    margin-top: 20px;
    margin-bottom: 10px;
}
.errorMessage{
    font-size: $fontE;
    color: #606266;
    margin-top: 10px;
    margin-bottom: 10px;
}
.return-button{
    margin-top: 20px;
    margin-bottom: 50px;
}
</style>